import Reveal from './Reveal';
import { wikiEntries } from '@/mocks/home';

export default function EncyclopediaIndex() {
  return (
    <section id="wiki" className="py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
            <div>
              <span className="text-xs tracking-[0.3em] text-secondary-700 uppercase">Wiki / 百科词条</span>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">词条索引</h2>
            </div>
            <p className="text-sm text-foreground-600 max-w-sm leading-relaxed">
              与人物相关的常用词条合集，像查目录一样逐条查阅。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
          {wikiEntries.map((entry, idx) => (
            <Reveal key={entry.term} delay={idx * 40}>
              <a
                href="#top"
                className="group flex items-center justify-between gap-4 py-4 border-b border-background-200 cursor-pointer"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-file-text-line text-base"></i>
                  </span>
                  <div className="min-w-0">
                    <h3 className="text-sm md:text-base font-medium text-foreground-950 group-hover:text-accent-700 transition-colors">
                      {entry.term}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 truncate">{entry.desc}</p>
                  </div>
                </div>
                <i className="ri-arrow-right-s-line text-lg text-background-400 group-hover:text-accent-600 transition-colors shrink-0"></i>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}